import  { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Layout from "./components/Layout";
import Footer from "./components/Footer";
import { routes } from "./routes/lazyRoutes";
import "./App.css";
// 路由组件
const AppRoutes = () => {

  return (
    <Layout>
      <Routes>
        {routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Routes>
    </Layout>
  );
};

// 主应用组件
const App = () => {
  return (
    <div className="App">
      <Router>
        <div className="App-content">
          <AppRoutes />
        </div>
        <Footer />
      </Router>
    </div>
  );
};

export default App;
